import { render } from "./NotificationsList.ce.vue?vue&type=template&id=38137ce4"
import script from "./NotificationsList.ce.vue?vue&type=script&lang=js"
export * from "./NotificationsList.ce.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__